import { render } from "./edit-admin.vue?vue&type=template&id=0a4a7d5f"
import script from "./edit-admin.vue?vue&type=script&lang=js"
export * from "./edit-admin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__